import { isSafeInternalPath } from "./is-safe-internal-path";

const FEDERATED_RETURN_PATH_KEY = "federated_return_path";

export function rememberFederatedReturnPath(path: string | null): void {
  if (path === null || !isSafeInternalPath(path)) {
    sessionStorage.removeItem(FEDERATED_RETURN_PATH_KEY);
    return;
  }
  sessionStorage.setItem(FEDERATED_RETURN_PATH_KEY, path);
}

export function takeFederatedReturnPath(): string | null {
  const stored = sessionStorage.getItem(FEDERATED_RETURN_PATH_KEY);
  sessionStorage.removeItem(FEDERATED_RETURN_PATH_KEY);

  if (stored === null || !isSafeInternalPath(stored)) {
    return null;
  }
  return stored;
}
